import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { DropdownOptionModel } from '../../../../Common/Forms/models/dropdown-option.model';
import { BulkActionFormComponent } from '../MonitoringBulkActionDialog/bulk-action-form.component';

@Component({
    selector: 'agpr-bulk-action-form-export',
    templateUrl: './bulk-action-form-export.component.html',
    styleUrls: ['./bulk-action-form-export.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BulkActionFormExportComponent),
            multi: true
        }],
    standalone: false
})
export class BulkActionFormExportComponent extends BulkActionFormComponent implements ControlValueAccessor {
    // TODO: localize?
    public fileTypes: DropdownOptionModel[] = [
        {
            label: '.csv',
            value: '.csv'
        }
    ];
    public selectedFileType = this.fileTypes[0];

    writeValue(fileType: any): void {
        const option = this.fileTypes.find(type => type.value === fileType);

        if (option) {
            this.selectedFileType = option;
        } else {
            this.selectedFileType = this.fileTypes[0];
            this.changed();
        }
    }
    changed(): void {
        this.onModelChange(this.selectedFileType.value);
    }
}
